import React from 'react'
import { Flex, Heading } from '@chakra-ui/react'
import { Rw1LogoColored } from '../icons/RW1LogoColored'
import { AccountPopover } from './AccountPopover'

const Header: React.FC = () => {
  return (
    <Flex
      height={20}
      width={'full'}
      alignItems={'center'}
      px={8}
      shadow={'sm'}
      justifyContent={'space-between'}>
      <Flex alignItems='center'>
        <Rw1LogoColored height={'10'} color={'text.1'} />
        <Heading color={'text.1'} size={'lg'}>
          | LMS Event Definition Tool
        </Heading>
      </Flex>
      <AccountPopover />
    </Flex>
  )
}

export default Header
